import { fetchAuthSession } from 'aws-amplify/auth';
import { graphqlClient } from '../../services/graphqlClient';
import type { Document } from '../../graphql/types';
import type { TimelineDocument } from '../../titleSearch/timeline';

/**
 * Loads the recorded documents of a Title Search for Findings mode, with the
 * same query `AnalyzeMode` uses for a job's documents (`listDocumentsByJob`),
 * following pagination. A finalized review stores the reviewer's edits and
 * rejections in `extractedFields`, which `titleSearch/timeline.ts` already
 * reads (edited values shown, rejected fields skipped).
 */

const isPreviewMode =
  import.meta.env.VITE_PREVIEW === 'true' || !import.meta.env.VITE_COGNITO_USER_POOL_ID;

export async function loadRecordedDocuments(jobId: string): Promise<TimelineDocument[]> {
  if (isPreviewMode) return [];
  const session = await fetchAuthSession();
  const tenantId =
    (session.tokens?.idToken?.payload['custom:tenantId'] as string) || 'default-tenant';

  const documents: Document[] = [];
  let token: string | undefined;
  do {
    const page = await graphqlClient.queries.listDocumentsByJob(jobId, tenantId, undefined, token);
    documents.push(...page.items);
    token = page.nextToken ?? undefined;
  } while (token);
  return documents;
}
